import { isOauthConfigProvided } from "./OAuthAPI_Producer";
import { isEmpty } from "../../vendor/lodash";

export function getRemoteNodes() {
  if (useLoginConfig()) {
    return remoteNodes;
  } else {
    return pg?.config?.remoteNodes;
  }
}

export function getRemoteServer() {
  if (useLoginConfig()) {
    return remoteNodes?.server1;
  } else {
    return pg?.config?.remoteNodes?.server1;
  }
}

export function getLocalHostProxy() {
  if (useLoginConfig()) {
    return localHostproxy;
  } else {
    return pg?.config?.proxy;
  }
}

export function getLocalAgent() {
  if (useLoginConfig()) {
    return localAgent;
  } else {
    return pg?.config?.localAgent;
  }
}
function useLoginConfig() {
  return (
    isOauthConfigProvided(OAuthConfigs) ||
    !isEmpty(remoteNodes?.server1.remoteServer)
  );
}
